<template>
  <div class="text-center">
    <v-bottom-sheet :value="value" :persistent="persistent" :disabled="disabled" @input="modalChange" :class="classes">
      <v-sheet class="text-center">
        <slot></slot>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>

export default {
  name: 'bh-bottom-sheet',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    }
  },
  methods: {
    modalChange(e) {
      this.$emit('modalChange', e)
    }
  }
}
</script>

<style scoped>
</style>
